import React, { useEffect, useState } from "react";
import CheckoutProducts from "../../components/Orders/CheckoutProducts";
import {
  AddressFetchApi,
  SelectDeliveryAddressApi,
} from "../../ApiCalls/Address";
import { FaPlus, FaMinus } from "react-icons/fa6";
import AddAddress from "../../components/Forms/AddAddress";
import { OrderCheckOutApi, OrderPlace } from "../../ApiCalls/OrderCheckout";
import MyOrderProductCard from "../../components/Orders/MyOrderProductCard";
import { TrendingProductsFetchApi } from "../../ApiCalls/TrendingProducts";
import SuccessPoP from "../../components/SuccessFullPopUp/SuccessPoP";
import Payment from "../Payment/Payment";
function AddressSelection() {
  const [isAddressOpen, setIsAddressOpen] = useState(true);
  const [selectedAddress, setSelectedAddress] = useState();
  const [fetchedAddress, setFetchedAddress] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addressToEdit, setAddressToEdit] = useState(null);
  const [fetchedOrder, setFetchedOrder] = useState([]);
  const [trendingProducts, setTrendingProducts] = useState([]);
  const [success, setSuccess] = useState(false);
  const [isSelectingAddress, setIsSelectingAddress] = useState(false);
  //pop up
  const [popup, setPopup] = useState({
    visible: false,
    success: false,
    button: false,
    message: "",
    subMessage: "",
    showCloseIcon: false,
    Trybutton: false,
  });

  const fetchAddressData = async () => {
    try {
      const addressData = await AddressFetchApi();
      setFetchedAddress(addressData.data);
      // console.log("Address data fetched:", addressData);
    } catch (error) {
      console.error("Failed to fetch address data:", error);
    }
  };

  const fetchOrderData = async () => {
    try {
      const orderData = await OrderCheckOutApi();
      setFetchedOrder(orderData);
      console.log("Order data fetched:", orderData);
    } catch (error) {
      console.error("Failed to fetch order data:", error);
    }
  };

  const fetchTrendingProducts = async () => {
    try {
      const tProducts = await TrendingProductsFetchApi();
      setTrendingProducts(tProducts);
    } catch (error) {
      console.error("Failed to fetch trending product data:", error);
    }
  };

  const handleEditClick = (address) => {
    setAddressToEdit(address);
    setIsModalOpen(true);
  };
  useEffect(() => {
    fetchOrderData();
    fetchAddressData();
    fetchTrendingProducts();
  }, []);

  const handleModel = () => {
    setAddressToEdit(null);
    setIsModalOpen(!isModalOpen);
  };
  //submit delivery address
  // const deliveryAddress = async (address) => {
  //   setSelectedAddress(address);
  //   try {
  //     const addressId = {
  //       default_address: selectedAddress,
  //     };
  //     await SelectDeliveryAddressApi(addressId);
  //     console.log("Address successfully posted:", address);
  //   } catch (error) {
  //     console.error("Error posting the selected address:", error);
  //   }
  // };
  const deliveryAddress = async (addressId) => {
    if (isSelectingAddress) return;

    setIsSelectingAddress(true);
    try {
      const response = await SelectDeliveryAddressApi({
        default_address: addressId,
      });
      console.log("Response from API:", response);
      if (response?.Status === "1") {
        setSelectedAddress(addressId); // ✅ Only set if success
        console.log("Address successfully posted:", addressId);
      } else {
        console.warn(
          "Server rejected address selection:",
          response?.message,
        );
      }
    } catch (error) {
      console.error("Error posting the selected address:", error);
    } finally {
      setIsSelectingAddress(false);
    }
  };

  //submit order
  const SubmitOrder = async () => {
    console.log("address delivery", selectedAddress);
    try {
      const response = await OrderPlace();

      if (response?.Status === "1") {
        setPopup({
          visible: true,
          success: true,
          button: true,
          showCloseIcon: false,
          message: "Order is Confirmed",
          subMessage: "Waiting for Seller approval",
        });
      } else {
        setPopup({
          visible: true,
          success: false,
          button: false,
          showCloseIcon: true,
          message: "Error while placing order",
          subMessage: response?.message || "Try Again",
        });
      }
    } catch (error) {
      console.log("Order error:", error);
      setPopup({
        visible: true,
        success: false,
        button: false,
        message: "Something went wrong",
        subMessage: "Please try again later",
      });
    }
  };

  return (
    <div className="flex w-full flex-col p-2 md:flex-row">
      <div className="w-full md:w-1/2">
        <h2 className="text-xl font-medium">Confirm Order & Checkout</h2>
        {/* checkout products  */}
        <div className="w-full">
          <CheckoutProducts fetchedOrder={fetchedOrder} />
        </div>
        <div className="p-2">
          {/* Accordion for Address Selection */}

          <div
            className="m-2 flex cursor-pointer items-center justify-between rounded-md bg-slate-100 p-4 font-medium"
            onClick={() => setIsAddressOpen(!isAddressOpen)}
          >
            <h3 className="text-lg">1. Select a delivery address</h3>
            {isAddressOpen ? <FaMinus /> : <FaPlus />}
          </div>
          {isAddressOpen && (
            <div className="transform p-4 transition-all duration-1000">
              {/* Address Selection Options */}
              {fetchedAddress.map((address) => (
                <div key={address.id} className="mb-2 flex items-start gap-3">
                  <div
                    className={`md:w flex w-full cursor-pointer items-center gap-5 rounded border p-2 ${
                      selectedAddress === address.id
                        ? "border-red-300 bg-red-200"
                        : "border-gray-200 bg-white"
                    }`}
                    onClick={() => deliveryAddress(address.id)} // Wrap in an anonymous function
                  >
                    <input
                      type="radio"
                      id={address.id}
                      name="address"
                      className="size-4 accent-green-600"
                      checked={selectedAddress === address.id}
                      onChange={() => deliveryAddress(address.id)}
                      disabled={isSelectingAddress}
                    />

                    <label
                      htmlFor={address.id}
                      className="cursor-pointer text-left"
                    >
                      <h3 className="text-sm font-medium">{address.name}</h3>
                      <p className="text-xs">
                        {address.housename}, {address.city}, {address.state},{" "}
                        {address.pincode}, {address.landmark}
                      </p>
                    </label>
                  </div>

                  <div className="mt-5">
                    <button
                      className="h-min w-16 rounded border border-gray-300 p-1 text-sm text-gray-600"
                      onClick={() => handleEditClick(address)}
                    >
                      Edit
                    </button>
                  </div>
                </div>
              ))}
              <div className="w-full p-1">
                <span
                  // onClick={() => setIsModalOpen(true)}
                  onClick={handleModel}
                  className="flex cursor-pointer items-center gap-2 text-xs text-green-600"
                >
                  {isModalOpen ? <FaMinus /> : <FaPlus />} Add new address
                </span>
              </div>
            </div>
          )}
          {/* AddAddress Modal */}
          {isModalOpen && (
            // <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="w-full rounded bg-white p-5">
              <AddAddress
                headHidden={true}
                closeModal={() => setIsModalOpen(false)}
                onAddressAdded={fetchAddressData}
                addressToEdit={addressToEdit}
              />
            </div>
            // </div>
          )}
        </div>
        <Payment
          selectedAddress={selectedAddress}
          SubmitOrder={SubmitOrder}
          setPopup={setPopup}
        />
      </div>
      <div className="w-full md:w-1/2">
        {/* order summery */}
        <div className="flex w-full flex-col justify-center p-3">
          <h2 className="text-2xl font-medium">Order Summary</h2>
          <div className="flex w-full flex-col items-center justify-center">
            <div className="w-full rounded-lg border p-4 text-sm">
              <div className="flex justify-between py-2">
                <span className="text-gray-600">Actual Price</span>
                <span className="font-medium text-gray-800">
                  {fetchedOrder.Data?.[0].currency_symbol} {fetchedOrder?.actual_prices}
                </span>
              </div>
              <div className="flex justify-between py-2">
                <span className="text-gray-600">Offer Price</span>
                <span className="font-medium text-gray-800">
                  {fetchedOrder.Data?.[0].currency_symbol} {fetchedOrder?.offer_price}
                </span>
              </div>
              <div className="flex justify-between py-2">
                <span className="text-gray-600">Quantity</span>
                <span className="font-medium text-gray-800">
                  {fetchedOrder?.Data?.length}
                </span>
              </div>
              <div className="flex justify-between py-2">
                <span className="text-gray-600">Delivery Charge</span>
                <span className="font-medium text-gray-800">
                 {fetchedOrder.Data?.[0].currency_symbol} {fetchedOrder?.delivery_charge}
                </span>
              </div>
              <div className="flex justify-between border-b py-2">
                <span className="text-gray-600">Expected Delivery</span>
                <span className="font-medium text-gray-800">{fetchedOrder?.Data?.[0]?.expected_delivery}</span>
              </div>
              <div className="flex justify-between py-2 text-lg font-semibold">
                <span>SUB TOTAL</span>
                <span>{fetchedOrder.Data?.[0].currency_symbol}{fetchedOrder?.total_price}</span>
              </div>
              {/* <div className="my-5 flex items-center justify-center">
                <button
                  onClick={SubmitOrder}
                  disabled={!selectedAddress} // Disable if no address selected
                  className={`w-3/4 p-3 text-white transition-colors duration-300 ${
                    selectedAddress
                      ? "bg-brand-button-green-bg hover:bg-green-600"
                      : "cursor-not-allowed bg-gray-400"
                  }`}
                >
                  Confirm Order
                </button>
              </div> */}
            </div>
          </div>
        </div>
        {/* trending products  */}
        <div className="hidden w-full items-center justify-center p-2 md:flex">
          <div className="w-2/3">
            <MyOrderProductCard
              products={trendingProducts.Data}
              title="Trending Products"
              layout="vertical-3-horizontal-2"
            />
          </div>
        </div>
      </div>
      {/* success pop up  */}

      {popup.visible && (
        // <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform  shadow-md w-fit h-fit rounded-lg  ">
        <div className="fixed inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
          <SuccessPoP
            message={popup.message}
            status={popup.success}
            button={popup.button}
            subMessage={popup.subMessage}
            showCloseIcon={popup.showCloseIcon}
            onClose={() => setPopup({ visible: false, success: false })}
            redirectPath="/"
            setPopup={setPopup}
            Trybutton={popup.Trybutton}
          />
        </div>
      )}
    </div>
  );
}

export default AddressSelection;
